import { axios } from '@/api/request'

/**
 * api接口列表
 */
const api = {
  login:'/qywxLogin/',
  getorders:'/teams/order/getshangwuorder/',


}

export function login (data) {
  return axios({
    url: api.login,
    method: 'post',
    data
  })
}

export function getorders (params) {
  return axios({
    url: api.getorders,
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/views/shangwuviews/orders/api.js